<template>
  <div class="monitorPoint">
    <Card>
      <Card :dis-hover="true" :bordered="false">
        <Row :gutter="20">
          <Form :label-width="100">
            <Col :span="6">
              <FormItem label="所在区域：">
                <Select transfer v-model="area" clearable @on-change="getMonitorPoint" @on-clear="getMonitorPoint">
                  <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem label="点位名称：">
                <Input v-model="pointName" placeholder="请输入点位名称" @on-blur="getMonitorPoint" clearable
                       @on-clear="getMonitorPoint"></Input>
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem label="是否在线">
                <Select transfer v-model="streamingstatus" @on-change="getMonitorPoint" clearable
                        @on-clear="getMonitorPoint">
                  <Option v-for="(item) in isLineList" :key="item.id" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="4">
              <Button @click="back" type="primary">返回 </Button>
            </Col>
          </Form>
        </Row>
      </Card>
      <Table
        :loading="dataLoading"
        :columns="columns"
        :data="data"
        :border="false"
        :stripe="false"
        :highlight-current-row="true"
      >
      </Table>
      <Page style="text-align: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="dataTotal"
            :page-size="pageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="currentPage"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
    <Modal title="视频" v-model="MonitorModalIsShow" @on-visible-change="visibleChange" :width="50" footer-hide>
      <div class="content">
        <jessibuca-video v-if="currentMonitorPoint&&currentMonitorPoint.streamingstatus === 'normal'" id="jessibuca"
                         ref="jessibuca" class="video"
                         :video-url="`${$videoUrl}/rtp/${currentMonitorPoint['deviceId']}_${currentMonitorPoint['deviceId']}.live.flv`"></jessibuca-video>
      </div>

    </Modal>
  </div>
</template>

<script>
import JessibucaVideo from '@/views/Screen/components/Video/JessibucaVideo.vue'

export default {
  name: "monitorPoint",
  components: {
    JessibucaVideo
  },
  data() {
    return {
      isLineList: [
        {id: 'normal', name: '在线'},
        {id: 'abnormal', name: '离线'}
      ],
      streamingstatus: '',
      countryList: [],
      area: '',
      pointName: '',
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '监控点位名称',
          align: 'center',
          width: '250',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.name)
          }
        },
        {
          title: '监控设备id',
          align: 'center',
          width: '200',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.deviceId)
          },
        },
        {
          title: '通道ID',
          align: 'center',
          width: '200',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.channelId)
          },
        },
        {
          title: '所属区域',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.region)
          },
        },
        {
          title: '摄像头类型',
          align: 'center',
          width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.cameratype === 1 ? '球型摄像机' : '枪式摄像机')
          },
        },
        {
          title: '监控流状态',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              on: {
                click: () => {
                  // e.preventDefault()
                  this.showMonitor(params.row)
                }
              },
              style: {
                color: params.row.streamingstatus === 'normal' ? '' : 'red'
              }
            }, params.row.streamingstatus === 'normal' ? '在线' : '离线')
          },
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      MonitorModalIsShow: false,
      currentMonitorPoint: {}
    }
  },
  mounted() {
    this.getMonitorPoint()
    this.getCountry()
  },
  methods: {
    back(){
      this.$router.push({name: 'stereoscopicInspection'})
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'stereoscopicInspection'
      })
    },
    visibleChange(flag) {
      if (flag) {
        this.playVideo()
      } else {
        this.close()
      }
    },
    playVideo() {
      this.$nextTick(() => {
        // const url = `ws://144.123.135.25:8091/rtp/${this.item['deviceId']}_${this.item['deviceId']}.live.flv`
        this.$refs.jessibuca.play()
      })
    },
    close() {
      this.$refs.jessibuca.destroy()
    },
    fullScreen() {
      this.$refs.jessibuca.fullscreen()
    },
    showMonitor(row) {
      if (row.streamingstatus === 'normal') {
        this.currentMonitorPoint = row
        this.MonitorModalIsShow = true
        this.playVideo()
      } else {
        this.$Message.error('该监控点位离线')
      }
    },
    //区县
    getCountry() {
      this.$http.get('/api/getAllCountys').then(res => {
        console.log(res)
        this.countryList = res.data
      })
    },
    editPoint(row) {
      this.$router.push({
        name: 'pointInfo',
        params: {
          row: row
        }
      })
    },
    getMonitorPoint() {
      this.dataLoading = true
      let params = {
        name: this.pointName === '' ? null : this.pointName,
        unitindexcode: this.area === '' ? null : this.area,
        streamingstatus: this.streamingstatus === '' ? null : this.streamingstatus,
        // pageNum: this.currentPage,
        // pageSize: this.pageSize
      }
      this.$http.post(`/api/point/monitorPoint?page=${this.currentPage}&&size=${this.pageSize}`, params).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          this.data = res.data.data.list
          this.dataTotal = res.data.data.total
          this.dataLoading = false
        }
      })
    },
    pageChange(page) {
      this.currentPage = page
      this.getMonitorPoint()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getMonitorPoint()
    },
  }
}
</script>

<style scoped lang="less">
.content {
  width: 100%;
  height: 400px;
  position: relative;

  .video {
    position: absolute;
    width: 100%;
    height: 100%;
    //height: 15vh;
    top: 0;
    left: 0;
  }
}
</style>
